import {
  get,
  post,
  del,
  put
} from '@/http/request'
import {
  HOST
} from '@/http/config'


// 新增通知
export function addPartyNotice(params) {
  return post(`${HOST}party_notice/save`, params)
}
// 修改通知
export function updatePartyNotice(params) {
  return put(`${HOST}party_notice/put`, params)
}
//通知
export function getPartyNotice(params) {
  return get(`${HOST}party_notice/list`, params)
}
//通知草稿箱列表
export function PartyNoticeDraftlist(params) {
  return get(`${HOST}party_notice/draftlist`, params)
}
//通知详情
export function PartyNoticeDetial(params) {
  return get(`${HOST}party_notice/listDetails`, params)
}
// 删除通知
export function delPartyNotice(params) {
  return del(`${HOST}party_notice/delete`, params)
}
//回复列表
export function replyDetails(params) {
  return get(`${HOST}party_notice/replyDetails`, params)
}
//接收列表
export function partyNoticeUserList(params) {
  return get(`${HOST}party_notice_user/list`, params)
}
//回复详情
export function partyNoticeUserDetial(params) {
  return get(`${HOST}party_notice_user/listDetails`, params)
}
// 通知确认
export function affirmPartyNotice(params) {
  return get(`${HOST}party_notice_user/affirmPartyNotice`, params)
}
// 撤回
export function withdrawParty(params) {
  return get(`${HOST}party_notice/withdrawParty`, params)
}
// 回复
export function updatepartyNoticeUser(params) {
  return put(`${HOST}party_notice_user/put`, params)
}
//获取人员分组列表
export function getSendList(params) {
  return get(`${HOST}sys-send/list`, params)
}
// 通过id获取文件信息
export function createWord(id) {
  return get(`${HOST}party_notice/partyWord`, { id })
}



// WEBPACK FOOTER //
// ./src/views/AccountingComputerizationNotice/api/api.js